// A folder item in the table or the grid: draggable like any item, and a drop
// target too — both under the table's namespaced dnd id, so the page's drop
// rules apply to either renderer.

import { useDroppable } from '@dnd-kit/core';
import { tableRowDndId } from '../DocumentTable/tableRowDndId';
import { useDragItem } from './useDragItem';

// A saving folder is about to be re-keyed: nothing may be dropped into it either.
export function useFolderDnd(folderId: string, disabled: boolean, saving: boolean) {
  const dndId = tableRowDndId(folderId);
  const { setNodeRef: setDragRef, attributes, listeners, isDragging, style } = useDragItem(dndId, 'folder', disabled);
  const { setNodeRef: setDropRef, isOver } = useDroppable({ id: dndId, disabled: saving });

  function setRef(el: HTMLElement | null) {
    setDragRef(el);
    setDropRef(el);
  }

  return { setRef, attributes, listeners, style, dropHighlight: isOver && !isDragging };
}
